import { render } from "./secret.vue?vue&type=template&id=5925d17b&ts=true"
import script from "./secret.vue?vue&type=script&lang=ts"
export * from "./secret.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__